import styles from './index.module.less'
import { Avatar, Badge, Button, Col, Image, Row } from 'antd'
import { Fragment, useRef } from 'react'
import { useMount, useSetState } from 'ahooks'
import { useFileUrlPrefix } from 'shj-utils'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { navigatePage } from '@/common/utils.ts'
import { getJumpUrl, getWorkOrder } from '@/services/workorder.ts'
import { UserOutlined } from '@ant-design/icons'
import { getClueDetail } from '@/services/callCenter'
import { getLink } from '@/pages/messageChat/MessageItem/link.ts'
import microApp from '@micro-zoe/micro-app'
import useWorkOrderStore from '@/store/workOrder.ts'
import useWorkshopStore from '@/store/workshop.ts'
import { useShallow } from 'zustand/react/shallow'
import queryParse from '@/utils/queryParse.ts'

function MessageItem(props) {
  const { style, index, data, onLoad, itemSize, avatar, onMount, onClick } = props
  const itemRef = useRef<any>()
  const navigate = useNavigate()
  const [filePrefix] = useFileUrlPrefix()
  const [state, setState] = useSetState({
    btnLoadingId: void 0,
  })
  useMount(() => {
    // if (!itemSize[index]) {
    //   onLoad?.(index, itemRef.current.getBoundingClientRect().height)
    // }
    onMount?.()
  })

  const { routeOfPath } = useWorkOrderStore(
    useShallow((state: any) => ({
      routeOfPath: state.routeOfPath,
    }))
  )

  const navigateBtnUrl = url => {
    const appPath = url.split('/').filter(d => !!d)[0]
    navigatePage(appPath, url.replace('/' + appPath, ''), navigate)
  }

  const handleBtnClick = (btn, item) => {
    const { businessId, businessType } = item
    if (item.click) {
      item.click?.()
    } else {
      if (businessId && businessType === 'workorder') {
        getJumpUrl(businessId).then(url => navigateBtnUrl(url))
      } else if (btn.url) {
        const url = getLink(btn.url) || ''
        if (url.startsWith('/')) {
          navigateBtnUrl(url)
        } else {
          window.open(url)
        }
      }
    }
  }

  const renderListItem = item => {
    if (item.fromId === 'CrmPlus') {
      if (!item.path && item?.body?.jumpUrl) {
        item.path = getLink(item?.body?.jumpUrl) || ''
      }
    }
    const onOpenUrl = item => {
      const path = item.path ?? item.body?.jumpUrl ?? ''
      const url = getLink(path) || ''
      if (path.startsWith('/saleOp/salesWorkBench/salesWorkBenchDetail/')) {
        const id = path.replace('/saleOp/salesWorkBench/salesWorkBenchDetail/', '')
        getClueDetail(id).then(() => {
          navigate(url)
        })
      } else {
        if (url.startsWith('/flow')) {
          // setState({ btnLoadingId: item.content })
          const splitUrl = url.split('?')
          const params = queryParse(splitUrl[1])
          getWorkOrder(params['itemId'])
            .then((res: any) => {
              const tab = res.status === 'COMPLETED' ? 'COMPLETED' : 'TODO'
              routeOfPath(splitUrl[0], {
                search: '?' + splitUrl[1] + `&tab=` + tab,
                replace: false,
                navigate,
                appName: 'flow',
              })
            })
            .finally(() => {
              setState({ btnLoadingId: void 0 })
            })
        } else {
          navigate(url)
        }
      }
    }
    return (
      <Badge dot style={{ visibility: data.read ? 'hidden' : 'visible' }}>
        <div className={styles.messageTip}>
          <div className={styles.tipTitle}>{item.title}</div>
          <div
            className={styles.tipContent}
            dangerouslySetInnerHTML={{ __html: item.content }}
          ></div>

          <Row className={styles.tipFooter} justify="space-between" align="bottom">
            <Col>
              <Row gutter={16}>
                {item.path || item.body?.jumpUrl ? (
                  <Col>
                    <Button
                      type="primary"
                      ghost
                      onClick={() => onOpenUrl(item)}
                      loading={state.btnLoadingId === item.content}
                    >
                      查看详情
                    </Button>
                  </Col>
                ) : null}

                {Array.isArray(item.buttons)
                  ? item.buttons
                      // .filter(d => !!d.url)
                      .map((d, i) => {
                        return (
                          <Col key={`button_${i}`}>
                            <Button
                              type="primary"
                              ghost
                              // href={d.url}
                              // target={'_blank'}
                              onClick={() => handleBtnClick(d, item)}
                            >
                              {d.name}
                            </Button>
                          </Col>
                        )
                      })
                  : null}
              </Row>
            </Col>

            {item.operate ? (
              <Col>
                <Row gutter={16}>
                  <Col>
                    <Button>拒绝</Button>
                  </Col>
                  <Col>
                    <Button type="primary">同意</Button>
                  </Col>
                </Row>
              </Col>
            ) : null}
          </Row>
        </div>
      </Badge>
    )
  }

  const renderAnnouncementItem = item => {
    return (
      <div
        className={classNames(styles.messageTip, styles.announceTip)}
        onClick={() => onClick?.(item, data)}
      >
        <div className={styles.imageWrap}>
          <Image
            src={item.coverUrl?.startsWith?.('http') ? item.coverUrl : filePrefix + item.coverUrl}
            width={'100%'}
            preview={false}
          />
        </div>

        <div className={styles.announceTitle}>{item.title}</div>
      </div>
    )
  }

  return (
    <div style={style} className={styles.messageItem} id={`MESSAGE_${data.uid}`}>
      <div ref={itemRef} className={styles.itemContent}>
        {/*<div className={styles.time}>{data.time}</div>*/}
        <Row gutter={10} wrap={false}>
          <Col>
            {/*<div className={styles.icon}></div>*/}
            <Avatar src={avatar} size={28} icon={<UserOutlined />} />
          </Col>
          <Col flex={1}>
            <div className={styles.name}>
              <Row gutter={18}>
                <Col> {data.name}</Col>
                <Col>{data.time}</Col>
              </Row>
            </div>
            {data.list.map((item, index) => {
              return (
                <Fragment key={`tip_${index}`}>
                  {{
                    ANNOUNCEMENT: renderAnnouncementItem(item),
                  }[item.contentType] || renderListItem(item)}
                </Fragment>
              )
            })}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default MessageItem
